import axios from "axios";
import { API_BASE_URL } from "configs/AppConfig";
import { signOutSuccess } from "store/slices/authSlice";
import store from "../store";
import { AUTH_TOKEN } from "constants/AuthConstant";
import { notification } from "antd";

const unauthorizedCode = [401, 403];
// const unauthorizedCode = [400, 401, 403]

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 120000,
});

// Config
const TOKEN_PAYLOAD_KEY = "Authorization";

// API Request interceptor
service.interceptors.request.use(
  (config) => {
    const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;

    if (jwtToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = `Bearer ${jwtToken}`;
    }

    return config;
  },
  (error) => {
    // Do something with request error here
    notification.error({
      message: "Error",
    });
    Promise.reject(error);
  }
);

// API respone interceptor
// service.interceptors.response.use((response) => {
// 	return response?.data
// }, (error) => {

// 	let notificationParam = {
// 		message: 'Something Wrong happened!'
// 	}

// 	// Remove token and redirect
// 	if (unauthorizedCode.includes(error.response?.status)) {
// 		notificationParam.message = 'Authentication Fail'
// 		notificationParam.description = 'Please login again'
// 		localStorage.removeItem(AUTH_TOKEN)
// 		store.dispatch(signOutSuccess())
// 	}

// 	if (error.response.status === 400) {
// 		notificationParam.message = error.response.data.message
// 	}
// 	if (error.response.status === 409) {
// 		notificationParam.message = error.response.data.message
// 	}

// 	if (error.response.status === 404) {
// 		notificationParam.message = error.response.data.message || 'Not Found'
// 	}

// 	// if (error.response.status === 500) {
// 	// 	notificationParam.message = 'Internal Server Error'
// 	// }

// 	if (error.response.status === 508) {
// 		notificationParam.message = 'Time Out'
// 	}

// 	notification.error(notificationParam)

// 	return Promise.reject(error);
// });

service.interceptors.response.use(
  (response) => {
    return response?.data;
  },
  (error) => {
    let notificationParam = {
      message: "Something went wrong!",
    };

    const status = error.response?.status;
    const data = error.response?.data;

    // Handle authentication failures
    if ([401, 403].includes(status)) {
      notificationParam.message = "Authentication Failed";
      notificationParam.description = "Please login again.";
      localStorage.removeItem(AUTH_TOKEN);
      store.dispatch(signOutSuccess());
    }

    // Handle specific errors
    if ([400, 409, 404, 422, 500].includes(status)) {
      // For validation error structure like { errors: { field: ['msg'] } }
      if (data?.errors && typeof data.errors === "object") {
        const validationMessages = Object.values(data.errors).flat().join(", ");
        notificationParam.message = "Validation Error";
        notificationParam.description = validationMessages;
      } else if (data?.message) {
        // If there's a message field
        notificationParam.message = Array.isArray(data.message)
          ? data.message.join(", ")
          : data?.message;
      }
    }

    if (status === 508) {
      notificationParam.message = "Request Timeout";
    }

    // Fallback message if nothing matched
    if (!notificationParam.message && data?.message) {
      notificationParam.message = data.message;
    }

    notification.error(notificationParam);

    return Promise.reject(error);
  }
);

export default service;
